import { apiSlice } from "../../Api/apiSlice";

const assignmentMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all assignments Mark
    getAssignmentsMark: builder.query({
      query: () => "/assignmentMark",
    }),
    // edit mark and status
    editAssignmentMark: builder.mutation({
      query: ({ data, id }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        console.log("arg", arg);
        const patchResult = dispatch(
          assignmentMarkApi.util.updateQueryData(
            "getAssignmentsMark",
            undefined,
            (draft) => {
              const asgMark = draft.find((a) => a.id == arg.id);
              asgMark.mark = arg.data.mark;
              asgMark.status = arg.data.status;
            }
          )
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),
  }),
});

export const { useGetAssignmentsMarkQuery, useEditAssignmentMarkMutation } =
  assignmentMarkApi;
